import { Capacitor } from "@capacitor/core";

// Detect native shell
export const isNative = () => {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
};

// ---------------- Biometric ----------------
// Uses @aparajita/capacitor-biometric-auth on native; gracefully returns false on web.
export async function isBiometricAvailable() {
  if (!isNative()) return { available: false, reason: "web" };
  try {
    const mod = await import("@aparajita/capacitor-biometric-auth");
    const r = await mod.BiometricAuth.checkBiometry();
    return { available: r.isAvailable, biometryType: r.biometryType, reason: r.reason };
  } catch (e) {
    return { available: false, reason: "plugin error" };
  }
}

export async function authenticateBiometric(reason = "Unlock TESLAM") {
  if (!isNative()) {
    throw new Error("Biometric login is only available on the iOS / Android app.");
  }
  const mod = await import("@aparajita/capacitor-biometric-auth");
  return mod.BiometricAuth.authenticate({
    reason,
    cancelTitle: "Cancel",
    allowDeviceCredential: true,
    iosFallbackTitle: "Use passcode",
    androidTitle: "TESLAM",
    androidSubtitle: reason,
  });
}

// ---------------- Push Notifications ----------------
export async function registerPushOnNative(onToken) {
  if (!isNative()) return;
  try {
    const mod = await import("@capacitor/push-notifications");
    const PushNotifications = mod.PushNotifications;
    const status = await PushNotifications.requestPermissions();
    if (status.receive !== "granted") return;
    await PushNotifications.register();
    PushNotifications.addListener("registration", (t) => onToken?.(t.value));
  } catch (e) {
    // plugin not configured
  }
}
